import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

const tabValues = ['map', 'kanban', 'tasks', 'calendar', 'contacts', 'roles'] as const
const REAL_ESTATE_LAST_TAB_STORAGE_KEY = 'gozoki.backOffice.realEstate.lastTab'

export const Route = createFileRoute('/_authenticated/development/real-estate/')({
  component: RealEstateIndex,
})

function RealEstateIndex() {
  const navigate = Route.useNavigate()

  useEffect(() => {
    let tab: (typeof tabValues)[number] = 'map'

    try {
      const saved = window.localStorage.getItem(REAL_ESTATE_LAST_TAB_STORAGE_KEY)
      if (saved && (tabValues as readonly string[]).includes(saved)) {
        tab = saved as (typeof tabValues)[number]
      }
    } catch {
      // ignore (private mode / blocked storage)
    }

    navigate({
      to: '/development/real-estate/$tab',
      params: { tab },
      replace: true,
      search: (prev) => ({ ...prev }),
    })
  }, [navigate])

  return null
}
